import React from 'react';
import Header from '../components/Header';
import MultiStepForm from '../components/Souscrire';


function Subscribe() {


    return (
        <div>
            <Header />
            <div className='bg-[#f2f2f2] w-full h-max'>
                <div className="flex items-start justify-center h-[93vh] bg-gray-100 pt-[30px]">
                    <div className='w-[95%] p-[20px] bg-white border border-gray-400 rounded-lg'>
                    <MultiStepForm/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Subscribe;